import {
  Avatar,
  Button,
  Division,
  Flex,
  Icon,
  Icons,
  Menu,
  Span,
  type MenuItemProps,
} from "@ir/ui";
import { useAdminAuth, useAuth } from "@src/presentation/hooks/auth";
import type { FC, Key } from "react";

const userMenuClassName = "sidebar-content-userMenu";

const userMenuItems: MenuItemProps[] = [
  {
    key: "logout",
    label: "Log Out",
    icon: <Icon size="small" name={Icons.Logout} />,
  },
];

const SidebarUserMenu: FC = () => {
  const auth = useAuth();

  const adminAuth = useAdminAuth();
  const adminUser = adminAuth.getUser();

  const handleSelect = async (optionKey: Key) => {
    if (optionKey === "logout") {
      await adminAuth.logout();
      await auth.logout();
    }
  };

  if (!adminUser) {
    return null;
  }

  return (
    <Division className={userMenuClassName}>
      <Menu items={userMenuItems} placement="top start" onSelect={handleSelect}>
        <Button
          variant="clear"
          color="primary"
          className="slide-navigation-item"
        >
          <Avatar
            size="small"
            boxShadow
            name={adminUser.fullName}
            src={adminUser.avatar ?? undefined}
            alt="avatar"
            aria-label="User Avatar"
            className="slide-navigation-icon"
          />
          <Flex direction="column" className="slide-navigation-label">
            <Span className="sidebar-user-name font-bold text-md text-grey-600">
              {adminUser.fullName}
            </Span>
            {adminUser.adminRoles.length > 0 && (
              <Span className="sidebar-user-role text-xs text-grey-500">
                {adminUser.adminRoles.map((role) => role.role_name).join(", ")}
              </Span>
            )}
          </Flex>
        </Button>
      </Menu>
    </Division>
  );
};
export default SidebarUserMenu;
